<template>
  <v-app>
    <weather-header />
    <v-main class="teal lighten-4">
      <router-view />
    </v-main>
    <weather-footer />
  </v-app>
</template>

<script>
import WeatherHeader from '@/components/WeatherHeader'
import WeatherFooter from '@/components/WeatherFooter'

export default {
  components: {
    WeatherHeader,
    WeatherFooter
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
html, body{
  overflow-y: auto;
}
</style>
